import src from "IMAGE";
export default { src, width: 798, height: 798, blurWidth: 0, blurHeight: 0};
